import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

/** メッセージ区分に応じたモーダルアイコン種別 */
type DialogIconKind = 'none' | 'warning' | 'error';

@Component({
  selector: 'app-navigation-confirm-dialog',
  imports: [NgOptimizedImage],
  templateUrl: './navigation-confirm-dialog.component.html',
  styleUrl: './navigation-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationConfirmDialogComponent {
  /** モーダルの表示/非表示 */
  isVisible = input<boolean>(false);

  /** タイトル */
  title = input<string>('');

  /** タイトルメッセージ */
  message = input<string>('');

  /** OKボタンラベル */
  okLabel = input<string>('はい');

  /** キャンセルボタンラベル */
  cancelLabel = input<string>('いいえ');

  /** メッセージ区分（I: 情報 / W: 確認 / E: エラー）。大文字小文字は区別しない */
  messageCategory = input('');

  /** OKボタン押下イベント */
  confirmed = output<void>();

  /** キャンセルボタン押下イベント */
  cancelled = output<void>();

  /** メッセージ区分から表示するアイコンを決定する */
  protected readonly iconKind = computed<DialogIconKind>(() => {
    const category = this.messageCategory().trim().toUpperCase();
    if (category === 'W') {
      return 'warning';
    }
    if (category === 'E') {
      return 'error';
    }
    return 'none';
  });

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
